import { useCallback } from 'react'
import useCart from './use-cart'
import {
  cartLineItemAddMutation,
  getCartId,
  cartCreate,
  normalizeShopifyCart,
} from '../utils'
import fetcherFn from '../utils/fetcher'
import type { HookFetcherFn } from '../utils/types'
import type { MaybeCart, AddItemHook } from '../types/cart'

export type UseAddItem = () => (input: any) => Promise<MaybeCart>
export type AddItemFetcher = HookFetcherFn<AddItemHook>

const useAddItem: UseAddItem = () => {
  const hookFetcher: AddItemFetcher = async (hookFetcherContext) => {
    const { input: item, options, fetch } = hookFetcherContext
    const lineItems = [
      {
        merchandiseId: item.variantId,
        quantity: item.quantity ?? 1,
        attributes: item.attributes || [],
        sellingPlanId: item.sellingPlanId || null,
      },
    ]

    let cartId = getCartId()

    if (!cartId) {
      const cart = await cartCreate(fetch, lineItems)
      return normalizeShopifyCart(cart.cart)
    }

    const { cartLinesAdd } = await fetch({
      ...options,
      variables: { cartId, lineItems },
    })

    return normalizeShopifyCart(cartLinesAdd.cart)
  }

  const { mutate } = useCart()
  const addItem = async (input: any) => {
    const hookFetcherContext = {
      input,
      fetch: fetcherFn,
      options: { query: cartLineItemAddMutation },
    }
    const data = await hookFetcher(hookFetcherContext)
    await mutate(data, false)
    return data
  }

  return useCallback(addItem, [mutate])
}

export default useAddItem
